export default {"src":"/_next/static/media/logo.49b7a0d4.svg","height":100,"width":156};